import { ProductCarousel } from '~/components/ProductCarousel'
import { SectionContainer } from '~/components/SectionContainer'
import { ProductsCarouselProps } from './ProductsCarousel.types'

export function ProductsCarousel({
  title,
  id,
  products = [],
  className,
  width = 'wide',
}: ProductsCarouselProps): React.JSX.Element {
  return (
    <SectionContainer
      width={width}
      wrapperClassName='mb-4'
      innerClassName='mt-10'>
      <ProductCarousel
        title={title}
        id={id}
        products={products}
        className={className}
      />
    </SectionContainer>
  )
}
